import client from './client'

export default {
  async getVideoDetail (vid) {
    const url = `/videos/${vid}/detail`
    const res = await client.get(url)
    return res && res.data && res.data.data
  },
  async getRecommendVideos (videoId, recNum = 20, isVertical = false) {
    const url = `/v3/videos/relations?videoId=${videoId}&recNum=${recNum}&isVertical=${isVertical}`
    const res = await client.get(url)
    return res && res.data && res.data.data
  },
  /**
   * 获取单个视频数据
   * @param {*} vid 视频Id
   * @param {*} platform 平台
   */
  async getVideoStatistic (vid, platform = 'ELDERWAND') {
    const url = `/statistic/v2/videos/${vid}`
    const res = await client.get(url, {
      headers: {
        platform
      }
    })
    return res.data.data
  },
  /**
   * 获取单个视频各种数据趋势
   * type: play=播放量 share=分享量 like=点赞量 comment=评论量
   * @param {*} vid
   * @param {*} token
   * @param {*} platform
   */
  async getVideoTendencyData (vid, type = 'play', period = 'hour', platform = 'ELDERWAND') {
    const url = `/statistic/v2/videos/${vid}/${type}/tendency`
    const res = await client.get(url, {
      params: {
        period
      },
      headers: {
        platform
      }
    })
    return res.data.data
  },
  /**
   * 获取播主视频数据
   * @param {*} platform
   */
  async getAuthorVideosStatistic (platform = 'ELDERWAND') {
    const url = '/statistic/v2/video'
    const res = await client.get(url, {
      headers: {
        platform
      }
    })
    return res.data.data
  },
  /**
   * 获取播主相关的趋势数据
   * @param {*} type
   * @param {*} period
   * @param {*} platform
   */
  async getAuthorVideosTendencyData (type = 'play', params = {period: 'hour'}, platform = 'ELDERWAND') {
    const url = `/statistic/v2/author/video/${type}/tendency/increment`
    const reqParams = {
      period: params.period
    }
    if (params.period !== 'hour' && params.start && params.end) {
      reqParams.start = params.start
      reqParams.end = params.end
    }
    const res = await client.get(url, {
      params: reqParams,
      headers: {
        platform
      }
    })
    return res.data.data
  },
  setUserScore (params) {
    const url = '/points/rule/record'
    return client.post(url, params)
  },
  // 金策999活动用户验证
  // jinceUser: 'get /verify/jinceUser',
  jinceUser () {
    const url = '/verify/jinceUser'
    return client.get(url)
  },
  // 有效观看
  shareRecord (params) {
    const url = '/shareRecord'
    return client.post(url, params)
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/video.js